export const SET_SIGN_IN_OPEN = 'SET_SIGN_IN_OPEN';
export const SET_SIGN_IN_CLOSE = 'SET_SIGN_IN_CLOSE';
export const SET_SIGN_UP_OPEN = 'SET_SIGN_UP_OPEN';
export const SET_SIGN_UP_CLOSE = 'SET_SIGN_UP_CLOSE';
export const SET_RESET_PASSWORD_OPEN = 'SET_RESET_PASSWORD_OPEN';
export const SET_RESET_PASSWORD_CLOSE = 'SET_RESET_PASSWORD_CLOSE';
export const SET_ONBOARDING_COMPONENT_EXP_VARIATION = 'SET_ONBOARDING_COMPONENT_EXP_VARIATION';
export const SET_ONBOARDING_COMPONENT_EXP_LOADED = 'SET_ONBOARDING_COMPONENT_EXP_LOADED';
